// plugin
export const SET_DEPLOY_PLUGIN_LIST = 'SET_DEPLOY_PLUGIN_LIST'
export const SET_DEPLOY_PLUGIN_LIST_PAGE = 'SET_DEPLOY_PLUGIN_LIST_PAGE'
export const SET_DEPLOY_PLUGIN_LIST_PAGE_TOTAL = 'SET_DEPLOY_PLUGIN_LIST_PAGE'
export const SET_DEPLOY_PLUGIN_LIST_QUERY = 'SET_DEPLOY_PLUGIN_LIST_PAGE'
export const SET_DEPLOY_PLUGIN_LIST_PAGE_SIZE = 'SET_DEPLOY_PLUGIN_LIST_PAGE'
// constraint
export const SET_CONSTRAINT_LIST = 'SET_CONSTRAINT_LIST'

// scriptVersion
export const SET_SCRIPT_VERSION_LIST = 'SET_SCRIPT_VERSION_LIST'
export const SET_SCRIPT_VERSION_LIST_PAGE = 'SET_SCRIPT_VERSION_LIST_PAGE'
export const SET_SCRIPT_VERSION_LIST_PAGE_TOTAL = 'SET_SCRIPT_VERSION_LIST_PAGE_TOTAL'
export const SET_SCRIPT_VERSION_LIST_PAGE_SIZE = 'SET_SCRIPT_VERSION_LIST_PAGE_SIZE'
export const SET_PLATFORM_LIST = 'SET_PLATFORM_LIST'
export const SET_SCRIPT_VERSION_QUERY = 'SET_SCRIPT_VERSION_QUERY'

// activityList
export const SET_ACTIVITY_LIST = 'SET_ACTIVITY_LIST'
export const SET_ACTIVITY_LIST_PAGE_TOTAL = 'SET_ACTIVITY_LIST_PAGE_TOTAL'
export const SET_ACTIVITY_LIST_PAGE_NUM = 'SET_ACTIVITY_LIST_PAGE_NUM'
export const SET_ACTIVITY_LIST_PAGE_SIZE = 'SET_ACTIVITY_LIST_PAGE_SIZE'
export const SET_ACTIVITY_LIST_PAGE_QUERY = 'SET_ACTIVITY_LIST_PAGE_QUERY'
export const SET_ACTIVITY_LIST_SEARCHING = 'SET_ACTIVITY_LIST_SEARCHING'

// activityDetail
export const SET_ACTIVITY_DETAIL_LIST = 'SET_ACTIVITY_DETAIL_LIST'
export const SET_ACTIVITY_DETAIL_LIST_PAGE_TOTAL = 'SET_ACTIVITY_DETAIL_LIST_PAGE_TOTAL'
export const SET_ACTIVITY_DETAIL_LIST_PAGE_NUM = 'SET_ACTIVITY_DETAIL_LIST_PAGE_NUM'
export const SET_ACTIVITY_DETAIL_LIST_PAGE_SIZE = 'SET_ACTIVITY_DETAIL_LIST_PAGE_SIZE'
export const SET_ACTIVITY_DETAIL_LIST_QUERY = 'SET_ACTIVITY_DETAIL_LIST_QUERY'
export const SET_ACTIVITY_DETAIL_TOTALAVALIABLE = 'SET_ACTIVITY_DETAIL_TOTALAVALIABLE'
export const SET_ACTIVITY_DETAIL = 'SET_ACTIVITY_DETAIL'
export const SET_ACTIVITY_DETAIL_SEARCHING = 'SET_ACTIVITY_DETAIL_SEARCHING'
export const SET_ACTIVITY_DETAIL_EXPORTING = 'SET_ACTIVITY_DETAIL_EXPORTING'

// error
export const SET_ERROR_LIST = 'SET_ERROR_LIST'
export const SET_ERROR_PAGE_TOTAL = 'SET_ERROR_PAGE_TOTAL'
export const SET_ERROR_QUERY = 'SET_ERROR_QUERY'
export const SET_ERROR_PAGE_SIZE = 'SET_ERROR_PAGE_SIZE'
export const SET_ERROR_PAGE_NUM = 'SET_ERROR_PAGE_NUM'
export const SET_ERROR_SEARCHING = 'SET_ERROR_SEARCHING'

// rendering-error
export const SET_RENDER_ERROR_LIST = 'SET_RENDER_ERROR_LIST'
export const SET_RENDER_ERROR_PAGE_TOTAL = 'SET_RENDER_ERROR_PAGE_TOTAL'
export const SET_RENDER_ERROR_QUERY = 'SET_RENDER_ERROR_QUERY'
export const SET_RENDER_ERROR_PAGE_SIZE = 'SET_RENDER_ERROR_PAGE_SIZE'
export const SET_RENDER_ERROR_PAGE_NUM = 'SET_RENDER_ERROR_PAGE_NUM'
export const SET_RENDER_ERROR_SEARCHING = 'SET_RENDER_ERROR_SEARCHING'

// calendar
export const SET_PREVIEW_DEPARTMENT = 'SET_PREVIEW_DEPARTMENT'
export const SET_DUTY_INFO = 'SET_DUTY_INFO'
export const SET_ADMIN_LIST = 'SET_ADMIN_LIST'
export const SET_REMARKS = 'SET_REMARKS'
export const SET_WEEK_ATTENDANCE = 'SET_WEEK_ATTENDANCE'

// administratorNotice
export const SET_ADMINISTRATORNOTICE_LIST = 'SET_ADMINISTRATORNOTICE_LIST'
export const SET_HISTORYNOTICE_LIST = 'SET_HISTORYNOTICE_LIST'
export const CHANGE_LOADING_STATE = 'CHANGE_LOADING_STATE'
export const SET_NOTICE_IDS = 'SET_NOTICE_IDS'

// nodeNotice
export const SET_NODENOTICE_LIST = 'SET_NODENOTICE_LIST'
export const SET_NODE_HISTORYNOTICE_LIST = 'SET_NODE_HISTORYNOTICE_LIST'
export const CHANGE_NODE_LOADING_STATE = 'CHANGE_NODE_LOADING_STATE'
export const SET_NODE_NOTICE_IDS = 'SET_NODE_NOTICE_IDS'

// clientPromotionNotice
export const SET_CLIENT_PROMOTION_NOTICE_LIST = 'SET_CLIENT_PROMOTION_NOTICE_LIST'
// export const SET_CLIENT_PROMOTION_NOTICE_LIST_PAGE = 'SET_CLIENT_PROMOTION_NOTICE_LIST_PAGE'
// export const SET_CLIENT_PROMOTION_NOTICE_LIST_PAGE_SIZE_TOTAL = 'SET_CLIENT_PROMOTION_NOTICE_LIST_PAGE_SIZE_TOTAL'
export const SET_CLIENT_PROMOTION_NOTICE_LIST_PAGE_COUNT =
  'SET_CLIENT_PROMOTION_NOTICE_LIST_PAGE_COUNT'
export const SET_CLIENT_PROMOTION_NOTICE_LIST_TOTAL = 'SET_CLIENT_PROMOTION_NOTICE_LIST_TOTAL'
export const SET_CLIENT_PROMOTION_NOTICE_LIST_PAGE_SIZE =
  'SET_CLIENT_PROMOTION_NOTICE_LIST_PAGE_SIZE'
// export const SET_SCROLL_DISABLE = 'SET_SCROLL_DISABLE'
// export const RESET_CLIENT_PROMOTION_NOTICE_LIST = 'RESET_CLIENT_PROMOTION_NOTICE_LIST'

// exchangeRate
export const SET_EXCHANGERATE_LIST = 'SET_EXCHANGERATE_LIST'

// clientSystemNotice
export const SET_CLIENT_SYSTEM_NOTICE_LIST = 'SET_CLIENT_SYSTEM_NOTICE_LIST'
export const SET_CLIENT_SYSTEM_NOTICE_LIST_PAGE_COUNT = 'SET_CLIENT_SYSTEM_NOTICE_LIST_PAGE_COUNT'

// plugin
export const SET_EXPORTING = 'SET_EXPORTING'
export const SET_DEPENDENCY_ALL_DEPENDENCE = 'SET_DEPENDENCY_ALL_DEPENDENCE'
export const SET_DEPENDENCY_NAME_VERSION_MAP = 'SET_DEPENDENCY_NAME_VERSION_MAP'

// prizePool
export const SET_PRIZE_POOL_ACTIVITY_LIST = 'SET_PRIZE_POOL_ACTIVITY_LIST'
export const SET_PRIZE_POOL_ACTIVITY_LIST_SORT = 'SET_PRIZE_POOL_ACTIVITY_LIST_SORT'
export const SET_PRIZE_POOL_ACTIVITY_LIST_PAGE_NUM = 'SET_PRIZE_POOL_ACTIVITY_LIST_PAGE_NUM'
export const SET_PRIZE_POOL_ACTIVITY_LIST_PAGE_TOTAL = 'SET_PRIZE_POOL_ACTIVITY_LIST_PAGE_TOTAL'
export const SET_PRIZE_POOL_ACTIVITY_LIST_PAGE_SIZE = 'SET_PRIZE_POOL_ACTIVITY_LIST_PAGE_SIZE'
export const SET_PRIZE_POOL_ACTIVITY_LIST_SEARCHING = 'SET_PRIZE_POOL_ACTIVITY_LIST_SEARCHING'
export const SET_PRIZE_POOL_ACTIVITY_LIST_LOADING = 'SET_PRIZE_POOL_ACTIVITY_LIST_LOADING'
export const SET_PRIZE_POOL_ACTIVITY_LIST_QUERY = 'SET_PRIZE_POOL_ACTIVITY_LIST_QUERY'
export const SET_PRIZE_LIST = 'SET_PRIZE_LIST'
export const SET_PRIZE_LIST_QUERY = 'SET_PRIZE_LIST_QUERY'
export const SET_PRIZE_LIST_PAGE_NUM = 'SET_PRIZE_LIST_PAGE_NUM'
export const SET_PRIZE_LIST_PAGE_SIZE = 'SET_PRIZE_LIST_PAGE_SIZE'
export const SET_PRIZE_LIST_PAGE_TOTAL = 'SET_PRIZE_LIST_PAGE_TOTAL'
export const SET_RECEIVE_DETAIL_LIST = 'SET_RECEIVE_DETAIL_LIST'
export const SET_RECEIVE_DETAIL_LIST_QUERY = 'SET_RECEIVE_DETAIL_LIST_QUERY'
export const SET_RECEIVE_DETAIL_LIST_SEARCHING = 'SET_RECEIVE_DETAIL_LIST_SEARCHING'
export const SET_RECEIVE_DETAIL_LIST_PAGE_TOTAL = 'SET_RECEIVE_DETAIL_LIST_PAGE_TOTAL'
export const SET_RECEIVE_DETAIL_LIST_PAGE_NUM = 'SET_RECEIVE_DETAIL_LIST_PAGE_NUM'
export const SET_RECEIVE_DETAIL_LIST_PAGE_SIZE = 'SET_RECEIVE_DETAIL_LIST_PAGE_SIZE'

// scheduleConfig
export const SET_USER_LIST_LOADING = 'SET_USER_LIST_LOADING'
export const SET_PLATFORM_LIST_LOADING = 'SET_PLATFORM_LIST_LOADING'
export const SET_AREA_LIST_LOADING = 'SET_AREA_LIST_LOADING'
export const SET_USER_LIST = 'SET_USER_LIST'
export const SET_SCHEDULE_PLATFORM_LIST = 'SET_SCHEDULE_PLATFORM_LIST'
export const SET_AREA_LIST = 'SET_AREA_LIST'

export const SET_CGFEENAME = 'SET_CGFEENAME'
export const SET_ADDITIONAL_CHARGES_EXIT_USERIDS = 'SET_ADDITIONAL_CHARGES_EXIT_USERIDS'

// client advertise
export const SET_CLIENT_AD_LIST = 'SET_CLIENT_AD_LIST'
export const SET_CLIENT_AD_LIST_PAGE_SIZE = 'SET_CLIENT_AD_LIST_PAGE_SIZE'
export const SET_CLIENT_AD_PAGE_COUNT = 'SET_CLIENT_AD_PAGE_COUNT'
export const SET_CLIENT_AD_LIST_TOTAL = 'SET_CLIENT_AD_LIST_TOTAL'
export const SET_CLIENT_AD_LIST_QUERY = 'SET_CLIENT_AD_LIST_QUERY'

// mini program advertise
export const SET_MINIPROGRAM_AD_LIST = 'SET_MINIPROGRAM_AD_LIST'
export const SET_MINIPROGRAM_AD_LIST_PAGE_SIZE = 'SET_MINIPROGRAM_AD_LIST_PAGE_SIZE'
export const SET_MINIPROGRAM_AD_PAGE_COUNT = 'SET_MINIPROGRAM_AD_PAGE_COUNT'
export const SET_MINIPROGRAM_AD_LIST_TOTAL = 'SET_MINIPROGRAM_AD_LIST_TOTAL'
export const SET_MINIPROGRAM_AD_LIST_QUERY = 'SET_MINIPROGRAM_AD_LIST_QUERY'

// overview page advertise
export const SET_OVERVIEW_AD_LIST = 'SET_OVERVIEW_AD_LIST'
export const SET_OVERVIEW_AD_LIST_PAGE_SIZE = 'SET_OVERVIEW_AD_LIST_PAGE_SIZE'
export const SET_OVERVIEW_AD_LIST_TOTAL = 'SET_OVERVIEW_AD_LIST_TOTAL'
export const SET_OVERVIEW_AD_PAGE_COUNT = 'SET_OVERVIEW_AD_PAGE_COUNT'

export const SET_BECOME_CGTALKS_LIST = 'SET_BECOME_CGTALKS_LIST'
export const SET_RECOMMEND_CGTALKS_LIST = 'SET_RECOMMEND_CGTALKS_LIST'
export const SET_REGISTER_CGTALKS_LIST = 'SET_REGISTER_CGTALKS_LIST'
export const SET_LOADING_CGTALKS_STATE = 'SET_LOADING_CGTALKS_STATE'

export const SET_BACKGROUND_LIST = 'SET_BACKGROUND_LIST'
export const SET_BACKGROUND_QUERY = 'SET_BACKGROUND_QUERY'
export const SET_BACKGROUND_SEARCHING = 'SET_BACKGROUND_SEARCHING'
export const SET_BACKGROUND_LIST_PAGE_SIZE = 'SET_BACKGROUND_LIST_PAGE_SIZE'
export const SET_BACKGROUND_PAGE_COUNT = 'SET_BACKGROUND_PAGE_COUNT'
export const SET_BACKGROUND_LIST_TOTAL = 'SET_BACKGROUND_LIST_TOTAL'
export const SET_BACKGROUND_LIST_QUERY = 'SET_BACKGROUND_LIST_QUERY'

// client slideshow
export const SET_CLIENT_SLIDESHOW_LIST = 'SET_CLIENT_SLIDESHOW_LIST'

// json template config
export const SET_JSON_TEMPLATE_QUERY = 'SET_JSON_TEMPLATE_QUERY'
export const SET_JSON_SEARCHING = 'SET_JSON_SEARCHING'
export const SET_JSON_LIST = 'SET_JSON_LIST'
